import { TranslateProcessor } from '@opm/hooks/useTranslateConfig';
import { categoryTranslateV2 } from '@opm/hooks/useTranslateConfig/utils';
import { getLocale } from 'umi';

/**
 * CompetitorsAdCreatives 翻译处理器
 *
 * 将 FilterCommon 的 backCondConfig 回调返回的 cond 数据
 * 转换为翻译方法集合，供页面内子组件使用
 */
export const createUgcCreativeTrendsProcessor = (): TranslateProcessor => {
  return cond => {
    // 处理类型配置
    const typeList = (cond?.ugc_trends_config_topic_types || []).flatMap(
      (item: any) => {
        const parent = {
          text: item.label_en,
          textCn: item.label_zh,
          value: item.value,
        };

        const children = (item.children || []).map((child: any) => ({
          text: child.label_en,
          textCn: child.label_zh,
          value: child.value,
        }));

        return [parent, ...children];
      },
    );

    return {
      translateType: categoryTranslateV2(typeList, getLocale),
    };
  };
};

export const ugcCreativeTrendsProcessor = createUgcCreativeTrendsProcessor();
